module.exports = __webpack_public_path__ + "img/waiting_time.b5800a36.svg";